import charging from '../../charging';

// Deprecated
export function startCharging(data) {
  return charging.post(`/start_charging`, data);
}
